import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import useGlobalStyles from '../../../useGlobalStyles';
import { Achievement } from '../../../../types';
import useAchievementItemStyles from './useAchievementItemStyles';

/**
 * Achievements component that renders the user's achievements.
 * @param achievements - the list of achievements to display.
 * @returns - the Achievements component.
 */
const AchievementItem: React.FC<{ achievement: Achievement }> = ({ achievement }) => {
  const { classes } = useAchievementItemStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const mapAchievementIcon = (icon: string) => {
    if (!icon) {
      return '';
    }
    if (icon.includes('5000')) {
      return `/assets/achievements/trophy8.png`;
    }
    if (icon.includes('1000')) {
      return `/assets/achievements/trophy7.png`;
    }
    if (icon.includes('500')) {
      return `/assets/achievements/trophy6.png`;
    }
    if (icon.includes('100')) {
      return `/assets/achievements/trophy5.png`;
    }
    if (icon.includes('50')) {
      return `/assets/achievements/trophy4.png`;
    }
    if (icon.includes('10')) {
      return `/assets/achievements/trophy3.png`;
    }
    if (icon.includes('5')) {
      return `/assets/achievements/trophy2.png`;
    }
    if (icon.includes('1')) {
      return `/assets/achievements/trophy1.png`;
    }
    return '';
  };

  return achievement.goal - achievement.progress > 0 ? (
    <Tooltip
      title={`Hint: ${achievement.description}`}
      placement='top'
      classes={{ tooltip: globalClasses.tooltip }}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -25],
            },
          },
        ],
      }}>
      <div className={classes.achievementItemContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/achievements/incomplete.png`}
          alt={achievement.name}
          className={classes.icon}
        />
        <div className={`${globalClasses.h6} ${classes.name}`}>{achievement.name}</div>
        <p className={`${globalClasses.p} ${classes.progress}`}>
          <b>{achievement.goal - achievement.progress}</b> more to go
        </p>
      </div>
    </Tooltip>
  ) : (
    <div className={classes.achievementItemContainer}>
      <img
        src={`${process.env.PUBLIC_URL}${mapAchievementIcon(achievement.icon)}`}
        alt={achievement.name}
        className={classes.icon}
      />
      <div className={`${globalClasses.h6} ${classes.name}`}>{achievement.name}</div>
      <p className={`${globalClasses.p} ${classes.description}`}>{achievement.description}</p>
    </div>
  );
};

export default AchievementItem;
